import {
	Column,
	Container,
	Email,
	Header,
	Link,
	PostonentsProvider,
	Row,
	Text,
} from 'postonents';
import React from 'react';

export default function AppAssigningNotifyEmail({ data }) {
	const {
		companyPageTitle = 'WITMEG',
		assignedAppNameList,
		assignedLocationNameList,
		assignedCompany,
		assignedOrganization,
		fullName,
	} = data;

	return (
		<PostonentsProvider
			theme={{ typo: { fontFamily: 'Roboto, sans-serif' } }}>
			<Email
				headLinks={[
					{
						type: 'link',
						props: {
							rel: 'stylesheet',
							href:
								'https://fonts.googleapis.com/css?family=Roboto:300,400,700',
						},
					},
				]}>
				<Container
					alignment='center'
					style={{ backgroundColor: '#FFFFFF', padding: '20px' }}>
					<Row>
						<Column small={12}>
							<Header
								style={{
									backgroundColor: '#FFFFFF',
									padding: 5,
								}}
								logo='https://cdn.neurolage.com/ecologital/witmeg_logo.png'
								logoHeight={100}
							/>
						</Column>
					</Row>

					<Row>
						<Column small={12}>
							<Text>Hi {fullName},</Text>
						</Column>
					</Row>

					<Row>
						<Column small={12}>
							<Text>
								You have been assigned to following Apps in{' '}
								{assignedCompany} Company of{' '}
								{assignedOrganization} Organization.
							</Text>
						</Column>

						<Column small={12}>
							<Text>
								<ul>
									<li>
										Apps: {assignedAppNameList.join(', ')}
									</li>
									<li>
										Locations:{' '}
										{assignedLocationNameList.join(', ')}
									</li>
								</ul>
							</Text>
						</Column>
					</Row>

					<Row>
						<Column small={12} style={{ marginBottom: 24 }}>
							<Text>
								Thanks,
								<br />
								{companyPageTitle}
							</Text>
						</Column>
					</Row>

					<Row>
						<Column small={12}>
							<Text>
								Any other questions? We are happy to help!
							</Text>
						</Column>

						<Column small={6}>
							<Link
								href='https://www.witmeg.com/contact-us'
								fullWidth
								type='hollow'>
								Help Center
							</Link>
						</Column>

						<Column small={6}>
							<Link
								href='mailto:info@ecologital.com'
								fullWidth
								type='hollow'>
								Email
							</Link>
						</Column>
					</Row>

					<Row>
						<Column
							small={12}
							style={{
								textAlign: 'center',
								fontSize: 12,
								lineHeight: '16px',
								fontWeight: 300,
							}}>
							Copyright © {' 2019-'} {new Date().getFullYear()}{' '}
							{companyPageTitle}, all rights reserved
						</Column>
					</Row>
				</Container>
			</Email>
		</PostonentsProvider>
	);
}
